import {
  UpdateCityRequest,
  UpdateCommunicationLanguageRequest,
  UpdateLanguageRequest,
} from './models';
import { TopLevelUserModel } from '../auth';
import { createMutation, createShared } from '@/logic/libs';
import { OtpResponse } from '@/services/otp';
import { UserModel } from '@/features/login-and-signup/types/user-model';

const url = 'auth';
const usersUrl = 'users';

export const useUpdateProfile = createMutation<Partial<UserModel>, Partial<UserModel>>({
  method: 'put',
  url: `${url}/profile`,
});

export const useUpdateAuthUserCity = createMutation<TopLevelUserModel, UpdateCityRequest>(
  {
    method: 'patch',
    url: `${usersUrl}/cities`,
  }
);

export const useUpdateLanguage = createMutation<TopLevelUserModel, UpdateLanguageRequest>(
  {
    method: 'patch',
    url: `${usersUrl}/language`,
  }
);

export const useUpdateCommunicationLanguage = createMutation<
  TopLevelUserModel,
  UpdateCommunicationLanguageRequest
>({
  method: 'patch',
  url: `${usersUrl}/communication-language`,
});

// change email flow services
export const useSendChangeEmailOtp = createShared<OtpResponse, unknown>(
  {
    method: 'post',
    url: `${url}/init-change-email`,
  },
  { queryOptions: { staleTime: 0, keepPreviousData: false } }
);
